import Model from '../models/model';

const model = new Model({
	name: 'Client',
	title: 'Client',
	defaultSort: 'ClientName',
	disableDelete: true,
	idProperty: 'ClientId',
	formTitleField: 'ClientName',
	showGridRefreshBtn: true,
	initialValues: {
		IsActive: true,

	},
	columns: [
		{ header: 'UniqueId', field: 'ClientId', width: 250 },
		{ header: 'ClientName', field: 'ClientName', width: 250 },
		{ header: 'Active', field: 'IsActive', type: 'boolean', width: 120 },
		{ header: 'License', field: 'GenerateLicenseClientId', width: 60, type: 'action' } // ToDo:- Discuss Action Columns with team
	]
});

export default model.createFormBase();
